import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Container } from 'reactstrap';

// ===============================================================================

// At runtime, Redux will merge together...
type StaticPageReloaderProps =
    RouteComponentProps;

// ===============================================================================

class StaticPageReloader extends React.PureComponent<StaticPageReloaderProps> {
    //This method is called when the component is first added to the document
    public componentDidMount() {
        window.location.href = "/Redirect?path=" + encodeURIComponent(window.location.pathname);
    }

    // ===============================================================================

    public render() {
        return (
            <Container>
                <div className="text-center">Loading...</div>
            </Container>
        );
    }
}

// ===============================================================================

export default connect(
)(StaticPageReloader as any);
